// Live "Displays as" line under Product Name. Formatting stays server-side
// (DisplayTitle.format), so this debounces input and asks the API.
var DEBOUNCE_MS = 400
var CACHE_LIMIT = 200

var cache = new Map()
var timer = null
var sequence = 0

function assertOk(response) {
  if (!response.ok)
    throw new Error("Request failed with status " + response.status)
  return response
}

function previewElements() {
  var preview = document.querySelector(".js-product-title-preview")
  var input = document.getElementById("product_title")
  if (!preview || !input) return null

  return {
    preview: preview,
    input: input,
    text: preview.querySelector(".js-product-title-preview-text"),
    url: preview.getAttribute("data-preview-url"),
  }
}

function show(els, displayTitle) {
  // Creator-controlled text: textContent only.
  els.text.textContent = displayTitle
  els.preview.hidden = false
}

// Map iterates in insertion order, so the first key is the oldest.
function remember(title, displayTitle) {
  if (cache.size >= CACHE_LIMIT) cache.delete(cache.keys().next().value)
  cache.set(title, displayTitle)
}

function refresh() {
  var els = previewElements()
  if (!els || !els.text || !els.url) return

  // Bump first so any in-flight response is stale, even on the blank and cache paths.
  var seq = ++sequence
  var title = els.input.value.trim()

  if (title === "") {
    els.preview.hidden = true
    return
  }

  if (cache.has(title)) {
    show(els, cache.get(title))
    return
  }

  fetch(els.url + "?" + new URLSearchParams({ title: title }), {
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  })
    .then(assertOk)
    .then(function (response) {
      return response.json()
    })
    .then(function (data) {
      var displayTitle =
        typeof data.display_title === "string" ? data.display_title : ""
      remember(title, displayTitle)
      if (seq === sequence) show(els, displayTitle)
    })
    .catch(function (error) {
      console.error("Title preview failed", error)
    })
}

function schedule() {
  clearTimeout(timer)
  timer = setTimeout(refresh, DEBOUNCE_MS)
}

$(document).on("input", "#product_title", schedule)

// The initial line is server-rendered; just stop a stale timer or response
// from the previous page.
$(document).on("turbolinks:load", function () {
  clearTimeout(timer)
  sequence++
})
